// extracted by mini-css-extract-plugin
export default {"languageContainer":"languageSwitch_languageContainer__8WcDF","isWhite":"languageSwitch_isWhite__p-y+q"};